import { useMemo, useRef } from "react";
import { toast } from "@a2z/ui";
import { capturePrivateSession, isPrivateSessionCurrent } from "@/lib/api/private-session";
export function usePrivateToast() {
  const lifetime = useRef(capturePrivateSession()).current;
  return useMemo(() => ({
    success: (...args: Parameters<typeof toast.success>) => { if (isPrivateSessionCurrent(lifetime)) toast.success(...args); },
    error: (...args: Parameters<typeof toast.error>) => { if (isPrivateSessionCurrent(lifetime)) toast.error(...args); },
    info: (...args: Parameters<typeof toast.info>) => { if (isPrivateSessionCurrent(lifetime)) toast.info(...args); },
  }), [lifetime]);
}
